export enum Category {
    RETAIL_SOFTWARE = 'Retail Software',
    RETAIL_APPS = 'Retail Apps',
    RETAIL_SCALES = 'Retail Scales',
    INDUSTRY_SOFTWARE = 'Industry Software',
    INDUSTRIAL_SCALES = 'Industry Scales',
    PRICE_LABELING = 'Price Labeling',
    FILLING_SYSTEMS = 'Filling Systems',
    FOOD_PROCESSING = 'Food Processing',
  }
  